import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RtlServiceService {

  constructor() { }

  setRTL() {
    document.documentElement.setAttribute('dir', 'rtl');
    document.documentElement.setAttribute('lang', 'ar');
  }



  setLTR() {
    document.documentElement.setAttribute('dir', 'ltr');
    document.documentElement.setAttribute('lang', 'en');
  }

  toggleDirection() {
    const dir = document.documentElement.getAttribute('dir');
    if (dir === 'rtl') {
      this.setLTR();
    } else {
      this.setRTL();
    }
  }
}
